import React from "react";

const BS5_Forms = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Forms Component</h2>
      <p>This is the BS5_Forms component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Forms;
